import * as React from 'react';
import { IconButton } from "@mui/material";
import CodeIcon from '@mui/icons-material/Code';

export class CodeButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            callback: props.callback
        }

        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick = () => {
        var x = Object.assign({}, this.state.customer);
        console.log('Edit button initiated',x);
        this.state.callback(this.state.data);
    }

    render() {
        return (
            <IconButton name="delete" className="iconCode" aria-label="Code" onClick={this._handleClick}>
                <CodeIcon className="iconWidget"/>
            </IconButton>            
        )
    }
}
